import { getPageMeta } from '@/routes-utils/get-page-meta';
import { IntroCard } from '../ct-stats.$username/cards';
import dummyAvatar from '../ct-stats.$username/dln.webp';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap';
import { CtStatsAbout } from './ct-stats-about';
import { CtWrappedSearchCta } from './search-cta';
import {
  ctWrappedCardPlaceholder,
  ctWrappedCards,
  ctWrappedContent,
  ctWrappedExtraPlaceholders,
  ctWrappedHero,
  ctWrappedHeroHeading,
  ctWrappedHeroHeadingContainer,
  ctWrappedHeroMainContainer,
  ctWrappedHeroSubheading,
} from './route.css';

export const meta = () => {
  return getPageMeta({
    title: 'Synoptic: Top stats about your CT account',
    previewDescription:
      'See stats of the most influential users in the CT network',
    previewImage: 'https://synoptic.com/static/og-user-stats-v2.webp',
    previewImageW: 600,
    previewImageH: 315,
    url: `https://synoptic.com/ct-stats`,
    twitterCreator: '@SynopticCom',
  });
};

export const handle: SeoHandle = {
  sitemap: true,
};

const PlaceholderCards = () => {
  return (
    <div className={ctWrappedCards}>
      <div className={ctWrappedCardPlaceholder} data-card="intro">
        {
          <IntroCard
            noLink
            userStats={{
              name: '38dln44',
              username: 'dln',
              icon_url: dummyAvatar,
              top_percentile: 80,
              rank: 6125,
              words: [
                'goblintown',
                'bullish',
                'vaporware',
                'GOAT',
                'blockchain',
              ],
              communities_percentiles: { '223': 76 },
              community: 223,
              reach: 3.2,
              reach_avg: 1,
              top_tweets: [
                {
                  icon_url: '',
                  id: '1',
                  like_count: 13500,
                  name: '',
                  quote_count: 0,
                  reply_count: 0,
                  retweet_count: 0,
                  text: '',
                  user_id: '1',
                  username: '',
                  view_count: 232000,
                },
              ],
            }}
          />
        }
      </div>
      <div className={ctWrappedCardPlaceholder} data-card="bridge" />
      <div className={ctWrappedCardPlaceholder} data-card="communities" />

      <div className={ctWrappedExtraPlaceholders}>
        <div className={ctWrappedCardPlaceholder} data-card="reach" />
        <div className={ctWrappedCardPlaceholder} data-card="flow" />
        <div className={ctWrappedCardPlaceholder} data-card="mutuals" />
        <div className={ctWrappedCardPlaceholder} data-card="regulars" />
        <div className={ctWrappedCardPlaceholder} data-card="heavyweights" />
        <div className={ctWrappedCardPlaceholder} data-card="loudestHits" />
        <div className={ctWrappedCardPlaceholder} data-card="replies" />
        <div className={ctWrappedCardPlaceholder} data-card="words" />
        <div className={ctWrappedCardPlaceholder} data-card="final" />
      </div>
    </div>
  );
};

export default function CtWrappedIndex() {
  return (
    <div className={ctWrappedContent}>
      <div className={ctWrappedHero}>
        <div className={ctWrappedHeroMainContainer}>
          <div className={ctWrappedHeroHeadingContainer}>
            <h1 className={ctWrappedHeroHeading}>
              Top stats about your CT account.
            </h1>
            <p className={ctWrappedHeroSubheading}>
              Name the legend we’re searching for.
            </p>
          </div>

          <CtWrappedSearchCta />
        </div>

        <CtStatsAbout />
      </div>

      <PlaceholderCards />
    </div>
  );
}
